import { createI18n } from "vue-i18n";
import Network from "~/utils/network";

const constantMessages = {
  ordinal_numbers: `nulla|egy|több`,
  relative_date: ({ named }) => {
    const days = Math.ceil((new Date(named("date")).getTime() - Date.now()) / 1000 / 60 / 60 / 24);
    return new Intl.RelativeTimeFormat(named("locale")).format(days, "day");
  },
};

export function setupI18n(options = { locale: "hu", legacy: false, allowDynamic: true, runtimeOnly: false }) {
  const i18n = createI18n(options);
  return i18n;
}

export function setI18nLanguage(i18n, locale) {
  if (i18n.mode === "legacy") {
    i18n.global.locale = locale;
  } else {
    i18n.global.locale.value = locale;
  }
}

export async function loadPublicMessages(i18n, locale) {
  try {
    const messages = await $fetch(`/api/tokens/public/${locale}`);
    i18n.global.setLocaleMessage(locale, Object.assign({}, messages, constantMessages));
  } catch (e) {
    console.log(e.message);
  }
}

export async function loadInternalMessages(i18n, locale) {
  try {
    const publicMessages = i18n.global.getLocaleMessage(locale);
    const internalMessages = await Network.http(`/api/tokens/internal/${locale}`);
    i18n.global.setLocaleMessage(locale, Object.assign({}, publicMessages, internalMessages, constantMessages));
  } catch (e) {
    console.log(e.message);
  }
}

export async function loadAllMessages(i18n, locale) {
  try {
    let publicMessages, internalMessages;
    try {
      publicMessages = await $fetch(`/api/tokens/public/${locale}`);
    } catch (e) {
      console.error("Couldn't fetch public tokens!");
      publicMessages = {};
    }
    try {
      internalMessages = await Network.http(`/api/tokens/internal/${locale}`);
    } catch (e) {
      console.error("Couldn't fetch internal tokens!");
      internalMessages = {};
    }
    i18n.global.setLocaleMessage(locale, Object.assign({}, publicMessages, internalMessages, constantMessages));
  } catch (e) {
    console.log(e.message);
  }
}

export function setFormats(i18n, locale, currency) {
  const datetimeFormat = {
    longNoYear: {
      month: "long",
      day: "numeric",
    },
    shortMonthName: {
      month: "short",
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    numeric: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    longDateTime: {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
    shortDateTime: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    },
    longDate: {
      year: "numeric",
      month: "long",
      day: "numeric",
    },
  };

  const numberFormat = {
    currency: {
      style: "currency",
      currency: currency,
      trailingZeroDisplay: "stripIfInteger",
    },
    percentMorePrecise: {
      style: "percent",
      roundingPriority: "morePrecision",
      maximumFractionDigits: 2,
      maximumSignificantDigits: 10,
    },
    percentLessPrecise: {
      style: "percent",
      roundingPriority: "lessPrecision",
    },
  };

  i18n.global.setDateTimeFormat(locale, datetimeFormat);
  i18n.global.setNumberFormat(locale, numberFormat);
}
